import configs from 'configs'

const xmlApi = ({ apiClient }) => ({
  /**
   * Fetches XML info for given sharedId and portal aliases.
   * @param {string} sharedId - The real estate shared_id
   * @param {string[]} portalAliases - List of portal aliases (e.g. ['grupo_olx', 'grupo_navent'])
   * @returns {Promise}
   */
  info(sharedId, portalAliases = []) {
    const aliases = portalAliases.join(',')
    return apiClient.rawRequest({
      url: `${configs.UHUB_URL}/api/real_estate_portal_xml/info/${sharedId}/${aliases}`,
      method: 'GET',
    })
  },
})

export default xmlApi
